import React from 'react';
import * as H from "../../hooks";
import Sentry from "../../Sentry";
import * as C from "../../Common";
import * as S from "../../services";
import { TC } from "../../Constants";
import { CircularProgress } from '@mui/material';

const Logout: React.FC = () => {
    H.useLanguage(undefined, true, true);

    React.useEffect(() => {
        localStorage.clear();
        Sentry.setUser({ id: "" });
        // Call an API that will reset the cache
        S.cleanCache().catch(console.error);
        // Get URL parameters to propagate to login page
        const urlParams = new URLSearchParams(window.location.search);
        const redirectUrl = urlParams.get('redirect');
        const loginUrl = redirectUrl ? `/login?redirect=${redirectUrl}` : '/login';
        // Redirect to Login page after 3 seconds
        const timer = setTimeout(() => window.location.href = loginUrl, 2500);
        return () => clearTimeout(timer);
    }, []);

    return <div className='flex-grow-1 text-center'>
        <C.Title level={3} text={TC.CURRENTLY_DISCONNECTING} />
        <C.Title level={6} className='text-muted mb-3' text={TC.LOGOUT_POLITE_THANKS} />
        <div children={<CircularProgress size={30} />} />
    </div>;
};

export default Logout;
